import { Action } from '@ngrx/store';

/**
 * ExportActionTypes
 */
export const enum ExportActionTypes {
  LOAD_EXPORT_BY = '[Export] Load Export By',
  CLEAR_EXPORT_BY = '[Export] Clear Export By',
}

/**
 * LoadExportBy
 */
interface LoadExportBy extends Action {
  type: ExportActionTypes.LOAD_EXPORT_BY;
  payload: any;
}

/**
 * ClearExportBy
 */
interface ClearExportBy extends Action {
  type: ExportActionTypes.CLEAR_EXPORT_BY;
}

/**
 * ExportActions
 */
export type ExportActions = LoadExportBy | ClearExportBy;
